import { api } from "utils/hostname";
import url from "url/index";
import { LanguageType } from "types/localization";
import { LanguageResponseType } from "types/Catalogs";
import { setServiceError } from "stores/settings";

const AWS_FLAGS_BASE_URL =
  "https://diswdgcu9cfva.cloudfront.net/flags-language/";

export const fetchLanguages = async (): Promise<LanguageType[]> => {
  try {
    const response = await api().get<LanguageResponseType>(
      url.config.api.catalogs.languages,
      {
        headers: { "f-v": import.meta.env.VITE_APP_VERSION_APP },
      },
    );

    if (response.data.statusCode >= 500) {
      setServiceError(true);
      throw new Error("Server error");
    }

    return response.data.languages.map((lang) => {
      const isoLower = lang.isoCode.toLowerCase();

      const item: LanguageType = {
        id: lang.id,
        name: lang.name,
        isoCode: isoLower,
        orig: lang.orig,
        img: `${AWS_FLAGS_BASE_URL}${isoLower}.svg`,
      };

      return item;
    });
  } catch (error) {
    throw new Error("Fetch languages error");
  }
};
